import Box from '@mui/material/Box';

export default function TabPanel({
    parentClass, selected, children, ...rest
}) {
    return (
        <Box
            className={parentClass ? `${parentClass}_tabpanel` : 'tabpanel'}
            role="tabpanel"
            overflow="auto"
            p={3}
            display={selected ? 'flex' : 'none'}
            flexDirection="column"
            height="100%"
            {...rest}
        >
            {children}
        </Box>
    );
}
